import React from 'react';
import { View, Text, Pressable, StyleSheet, Platform } from 'react-native';
import { ADMIN_FONT } from '../../config/theme/adminColors';

const isWeb = Platform.OS === 'web';

// Tooltip que aparece no hover do mouse.
//
// Diferente do `TooltipCustom` (react-native-elements), que abre no CLIQUE e
// precisa de overlay próprio: aqui basta apontar. Usa o estado `hovered` que o
// Pressable do react-native-web entrega na função filho — no app nativo não
// existe hover, então o tooltip simplesmente nunca aparece e o toque segue
// acionando o `onPress` normalmente.
//
// `label` também vira `accessibilityLabel`, então leitores de tela recebem a
// mesma informação que o mouse.
//
// `maxWidth`: opcional, para mensagens mais longas (ex.: erro de envio de
// notificação) — sem ele a bolha continua de uma linha só (`nowrap`), o
// padrão usado nos ícones do cabeçalho.
const HoverTooltip = ({
  label,
  onPress,
  children,
  placement = 'bottom',
  style,
  maxWidth,
  ...rest
}) => (
  <Pressable
    onPress={onPress}
    accessibilityLabel={label}
    accessibilityRole={onPress ? 'button' : undefined}
    // Repassa o que sobrar — ex.: `dataSet={{ noDrag: 'true' }}`, usado nas
    // listas com drag and drop para o gesto não engolir o clique.
    {...rest}
    // `zIndex` no GATILHO, não só na bolha: a bolha é filha dele, então herda o
    // empilhamento do pai. Sem isto ela é pintada atrás de qualquer irmão que
    // venha depois na árvore (era o caso dos botões abaixo do cabeçalho).
    // Sem onPress o elemento é só um indicador: não deve parecer clicável.
    style={[{ cursor: onPress ? 'pointer' : 'default', zIndex: 50 }, style]}
  >
    {({ hovered }) => (
      <>
        {children}
        {/* Só na web: no nativo não existe hover, e o estilo da bolha usa
            `translateX` percentual e `whiteSpace`, que são exclusivos do DOM. */}
        {isWeb && hovered ? (
          <View
            pointerEvents="none"
            style={[
              styles.bubble,
              placement === 'top' ? styles.top : styles.bottom,
              maxWidth ? { maxWidth, whiteSpace: 'normal' } : null,
            ]}
          >
            <Text
              style={[styles.text, maxWidth ? { whiteSpace: 'normal' } : null]}
              numberOfLines={maxWidth ? undefined : 1}
            >
              {label}
            </Text>
          </View>
        ) : null}
      </>
    )}
  </Pressable>
);

const styles = StyleSheet.create({
  bubble: {
    position: 'absolute',
    alignSelf: 'center',
    // Centraliza a bolha no ícone sem depender de medir a largura dela.
    left: '50%',
    transform: [{ translateX: '-50%' }],
    backgroundColor: 'rgba(31,41,55,0.95)',
    borderRadius: 6,
    paddingVertical: 5,
    paddingHorizontal: 9,
    zIndex: 50,
  },
  bottom: { top: '100%', marginTop: 6 },
  top: { bottom: '100%', marginBottom: 6 },
  text: {
    fontFamily: ADMIN_FONT,
    fontSize: 12,
    color: '#FFFFFF',
    whiteSpace: 'nowrap',
  },
});

export default HoverTooltip;
